import {fetchWithAuth} from '../util/fetch';
import {EndpointURL} from '../constants';
import {actionFactory} from '../util/redux-helpers';

export const ACTIONS = {

  LoadCompaniesInProgress: 'companiesEndpoint/LOAD_COMPANIES_INPROGRESS',
  LoadCompaniesFailed: 'companiesEndpoint/LOAD_COMPANIES_FAILED',
  LoadCompaniesCompleted: 'companiesEndpoint/LOAD_COMPANIES_COMPLETED'
};

const LoadCompaniesInProgress = actionFactory(ACTIONS.LoadCompaniesInProgress);
const LoadCompaniesFailed = actionFactory(ACTIONS.LoadCompaniesFailed);
const LoadCompaniesCompleted = actionFactory(ACTIONS.LoadCompaniesCompleted);

export function LoadCompaniesEpic() {
  return async (dispatch) => {
    dispatch(LoadCompaniesInProgress());
    let companiesResult = await fetchWithAuth(`${EndpointURL}admin/companies`);
    if (companiesResult.status === 200){
      dispatch(LoadCompaniesCompleted(await companiesResult.json()));
    } else {
      let err = await companiesResult.text();
      dispatch(LoadCompaniesFailed(err));
    }
    return Promise.resolve();
  };
}


// WEBPACK FOOTER //
// ./src/actions/companies.actions.js